module.exports = __webpack_public_path__ + "img/3d.82c31836.png";